import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { BsFacebook, BsGoogle, BsTwitter } from "react-icons/bs";
import ApiService from "../../services/ApiService";
import {
  saveTokenInLocalStorage,
  subscriptionTrial,
} from "../../services/AuthService";
import { callAlert } from "../../services/CommonService";
import { FaFacebookF } from "react-icons/fa";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import { handleEncrypt } from "../../services/CryptoService";
function RegisterModal(props) {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setConfirmShowPassword] = useState(false);

  let errorsObj = { email: "", password: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [loader, setLoader] = useState(false);
  const [languages, setLanguages] = useState();

  // const dispatch = useDispatch();
  const navigate = useNavigate();
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [captchaErrorMessage, setCaptchaErrorMessage] = useState("");
  const [states, setStates] = useState();

  const passwordRegex =
    /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  function validatePassword(password) {
    return passwordRegex.test(password);
  }

  const [fullName, setFullName] = useState("");

  useEffect(() => {
    const nameParts = fullName.trim().split(/\s+/);

    let firstName = "";
    let middleName = "";
    let lastName = "";

    if (nameParts.length === 1) {
      firstName = nameParts[0];
    } else if (nameParts.length === 2) {
      [firstName, lastName] = nameParts;
    } else if (nameParts.length >= 3) {
      firstName = nameParts[0];
      lastName = nameParts[nameParts.length - 1];
      middleName = nameParts.slice(1, -1).join(" ");
    }

    setState({
      ...state,
      firstName: firstName,
      middleName: middleName,
      lastName: lastName,
    });
  }, [fullName]);

  const [tncCheck, setTncCheck] = useState(false);

  const [state, setState] = React.useState({
    username: "",
    email: "",
    mobile: "",
    password: "",
    confirmpassword: "",
    salutation: "",
    firstName: "",
    middleName: "",
    lastName: "",
    board: "",
    DOB: "",
    grade: "",
    school: "",
    address: "",
    city: "",
    state: "",
    fatherName: "",
    alternativeNo: "",
    tnc: false,
    language: "",
  });

  function onChange(value) {
    console.log("Captcha value:", value);
    setCaptchaVerified(true); // Set captcha verification status
  }

  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await ApiService.publicGetRequest(
          "/additional/findallcategory",
        );
        setCategories(response.data.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    const fetchLanguages = async () => {
      try {
        const response = await ApiService.publicGetRequest(
          "/additional/activeLanguageList",
        );
        setLanguages(response.data.data);
      } catch (error) {
        console.error("Error fetching languages:", error);
      }
    };
    const fetchStates = async () => {
      try {
        const response =
          await ApiService.publicGetRequest("/additional/states");
        setStates(response.data.data);
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };

    fetchCategories();
    fetchLanguages();
    fetchStates();
  }, []);

  useEffect(() => {
    const fetchSubCategories = async (categoryId) => {
      try {
        const response = await ApiService.publicGetRequest(
          `/additional/findsubcategories?categoryId=${categoryId}`,
        );
        setSubcategories(response.data.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchSubCategories(state.board);
  }, [state.board]);

  function reset(ev) {
    ev.preventDefault();
    setState({
      username: "",
      email: "",
      mobile: "",
      password: "",
      confirmpassword: "",
      salutation: "",
      firstName: "",
      middleName: "",
      lastName: "",
      board: "",
      DOB: "",
      grade: "",
      school: "",
      address: "",
      city: "",
      state: "",
      fatherName: "",
      alternativeNo: "",
      tnc: false,
      language: "",
    });
  }

  const onSignUp = (e) => {
    e.preventDefault();
    let error = false;
    var re = /\S+@\S+\.\S+/;
    const errorObj = { ...errorsObj };

    if (!captchaVerified) {
      setCaptchaErrorMessage("Please complete the CAPTCHA!");
      return;
    }

    // if (state.username === "") {
    //     errorObj.username = "Please enter username";
    //     error = true;

    // }

    if (state.email === "") {
      errorObj.email = "Please enter email id";
      error = true;
    }

    if (state.email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(state.email)) {
        errorObj.email = "";
        error = false;
      } else {
        errorObj.email = "You have entered an invalid email address!";
        error = true;
      }
    }

    if (state.password === "") {
      errorObj.password = "Please enter password";
      error = true;
    }
    if (state.state === "") {
      errorObj.state = "Please enter state";
      error = true;
    }

    if (state.mobile === "") {
      errorObj.phone = "Please enter mobile no";
      error = true;
    } else if (!/^\d{10}$/.test(state.mobile)) {
      // Regex for a 10-digit mobile number
      errorObj.phone = "Please enter a valid 10-digit mobile number";
      error = true;
    }
    if (state.alternativeNo === "") {
    } else if (!/^\d{10}$/.test(state.alternativeNo)) {
      // Regex for a 10-digit mobile number
      errorObj.alternativeNo = "Please enter a valid 10-digit mobile number";
      error = true;
    }

    if (state.confirmpassword === "") {
      errorObj.confirmpassword = "Please enter confirm password";
      error = true;
    } else if (state.password !== state.confirmpassword) {
      errorObj.confirmpassword = "Confirm passwords don't match";
      error = true;
    }

    if (!validatePassword(state.password)) {
      errorObj.password +=
        " Password must contain at least 8 characters, including at least one uppercase letter, one digit, and one special character (@$!%*?&)";
      error = true;
    }

    if (state.salutation === "") {
      errorObj.salutation = "Please select salutation";
      error = true;
    }
    if (fullName === "") {
      errorObj.fullName = "Please enter name";
      error = true;
    }
    if (state.grade === "") {
      errorObj.grade = "Please enter grade";
      error = true;
    }
    if (state.board === "") {
      errorObj.board = "Please enter board";
      error = true;
    }
    // if (state.language === "") {
    //   errorObj.language = "Please select language";
    //   error = true;
    // }
    if (state.tnc === false) {
      errorObj.tnc = "Please accept terms & conditions";
      error = true;
    }
    console.log(error);
    console.log(errorObj);
    setErrors(errorObj);
    if (error) return;
    setLoader(true);

    ApiService.postRequest(
      "/users/signup",
      {
        username: state.email.toLowerCase(),
        email: state.email.toLowerCase(),
        mobile: state.mobile,
        password: handleEncrypt(state.password),
        salutation: state.salutation,
        firstName: state.firstName,
        middleName: state.middleName,
        lastName: state.lastName,
        DOB: state.DOB,
        grade: state.grade,
        // category: "icse",
        category: state.board,
        school: state.school,
        address: state.address,
        city: state.city,
        stateId: state.state,
        fatherName: state.fatherName,
        alternativeNo: state.alternativeNo,
        roles: ["ROLE_STUDENT"],
        // userLang: state.language,
        userLang: "en",
      },
      false,
    )
      .then((response) => {
        setLoader(false);
        console.log(response.data.data);

        if (response?.data?.data) {
          setState({
            username: "",
            email: "",
            mobile: "",
            password: "",
            confirmpassword: "",
            salutation: "",
            firstName: "",
            middleName: "",
            lastName: "",
            board: "",
            DOB: "",
            grade: "",
            school: "",
            address: "",
            city: "",
            fatherName: "",
            alternativeNo: "",
          });

          saveTokenInLocalStorage(response?.data?.data);
          /*  setTimeout((d) => {
           subscriptionTrial(d=>{ 
                                       navigate(`/user/dashboard`, { 
                                       });
                               });
          }, 500); */

          callAlert(
            "",
            "Your account has been  created successfully, Please login your account",
            "success",
            1000,
          );

          setTimeout((d) => {
            navigate("/login");
          }, 5000);
        } else {
          callAlert("", response?.data?.message);
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log(error, "eeeeeeeeeeeeeeeeeeee");
        callAlert(error?.error?.message);
      });
  };

  return (
    <div className="container">
      {/* use this button to trigger this modal */}
      {/* <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#loginModal">
        Login
    </button> */}

      <div
        className="modal fade"
        id="registerModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="registerModalTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title fw-bold" id="registerModalTitle">
                Register
              </h3>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body d-flex justify-content-center mb-3  bg-white">
              <div className="  col-md-12">
                <div className="row justify-content-center">
                  <div className="col-md-10">
                    <h4 className="text-center mb-4 mt-4 ">
                      Sign up and start learning
                    </h4>
                    {props.errorMessage && (
                      <div className="text-danger">{props.errorMessage}</div>
                    )}
                    {props.successMessage && (
                      <div className="text-danger">{props.successMessage}</div>
                    )}
                    <form onSubmit={onSignUp}>
                      <div className="row">
                        {/* <div className="col-md-6">
                                                    <div className="form-group mb-3">
                                                        <input
                                                            defaultValue={state.username}
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Username*"
                                                            onChange={(ev) => {
                                                                setState({
                                                                    ...state,
                                                                    username: ev.target.value,
                                                                });
                                                            }}
                                                        />
                                                        {errors.username && (
                                                            <div className="text-danger">
                                                                {errors.username}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div> */}
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <input
                              defaultValue={state.email}
                              className="form-control"
                              placeholder="Email ID*"
                              type="email"
                              onChange={(ev) => {
                                setState({
                                  ...state,
                                  email: ev.target.value,
                                });
                              }}
                            />
                            {errors.email && (
                              <div className="text-danger">{errors.email}</div>
                            )}
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-3   position-relative">
                            <Form.Select
                              className="form-control"
                              aria-label="Default select example"
                              name="selectOption"
                              value={state.salutation}
                              onChange={(ev) => {
                                setState({
                                  ...state,
                                  salutation: ev.target.value,
                                });
                              }}
                            >
                              <option>Select salutation *</option>
                              <option value="Mr">Mr.</option>
                              <option value="Ms">Ms.</option>
                              <option value="Miss">Miss.</option>
                              <option value="Mrs">Mrs</option>
                            </Form.Select>
                            {errors.salutation && (
                              <div className="text-danger">
                                {errors.salutation}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-3   position-relative">
                            <input
                              defaultValue={state.fullName}
                              type="text"
                              className="form-control"
                              placeholder="Full Name*"
                              onChange={(ev) => {
                                setFullName(ev.target.value);
                              }}
                            />
                            {errors.fullName && (
                              <div className="text-danger">
                                {errors.fullName}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* <div className="col-md-6">
                                                    <div className="mb-3   position-relative">
                                                        <input
                                                            defaultValue={state.firstName}
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="First Name*"
                                                            onChange={(ev) => {
                                                                setState({
                                                                    ...state,
                                                                    firstName: ev.target.value,
                                                                });
                                                            }}
                                                        />
                                                        {errors.firstName && (
                                                            <div className="text-danger">
                                                                {errors.firstName}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3   position-relative">
                                                        <input
                                                            defaultValue={state.middleName}
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Middle Name"
                                                            onChange={(ev) => {
                                                                setState({
                                                                    ...state,
                                                                    middleName: ev.target.value,
                                                                });
                                                            }}
                                                        />
                                                        {errors.middleName && (
                                                            <div className="text-danger">
                                                                {errors.middleName}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3   position-relative">
                                                        <input
                                                            defaultValue={state.lastName}
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Last name"
                                                            onChange={(ev) => {
                                                                setState({
                                                                    ...state,
                                                                    lastName: ev.target.value,
                                                                });
                                                            }}
                                                        />
                                                        {errors.lastName && (
                                                            <div className="text-danger">
                                                                {errors.lastName}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div> */}

                        <div className="col-md-6">
                          <div className="mb-3   position-relative">
                            <Form.Select
                              className="form-control"
                              aria-label="Default select example"
                              name="selectOption"
                              value={state.board}
                              onChange={(ev) => {
                                setState({
                                  ...state,
                                  board: ev.target.value,
                                });
                              }}
                            >
                              <option>Select Board * </option>

                              {categories &&
                                categories.map((category) => (
                                  <option key={category.id} value={category.id}>
                                    {category.name}
                                  </option>
                                ))}
                            </Form.Select>
                            {errors.board && (
                              <div className="text-danger">{errors.board}</div>
                            )}
                          </div>
                        </div>

                        {/* <div className="col-md-6">
                                                    <div className="mb-3   position-relative">

                          <input
                            defaultValue={state.DOB}
                            type="text"
                            className="form-control"
                            placeholder="DOB"
                            onChange={(ev) => {
                              setState({ ...state, DOB: ev.target.value });
                            }}
                          />
                          {errors.DOB && <div className="text-danger">{errors.DOB}</div>}
                        </div> */}

                        {/* <div className="mb-3   position-relative">
                                                        <DatePicker
                                                            selected={state.DOB}
                                                            onChange={(date) => {
                                                                setState({ ...state, DOB: date });
                                                            }}
                                                            className="form-control"
                                                            placeholderText="Date of birth"
                                                        />
                                                        {errors.DOB && (
                                                            <div className="text-danger">{errors.DOB}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3   position-relative">
                                                        <input
                                                            defaultValue={state.fatherName}
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Father name"
                                                            onChange={(ev) => {
                                                                setState({
                                                                    ...state,
                                                                    fatherName: ev.target.value,
                                                                });
                                                            }}
                                                        />
                                                        {errors.fatherName && (
                                                            <div className="text-danger">
                                                                {errors.fatherName}
                                                            </div>
                                                        )}
                                                    </div>
                                            </div> */}

                        <div className="col-md-6">
                          <div className="mb-3   position-relative">
                            <Form.Select
                              className="form-control"
                              aria-label="Default select example"
                              name="selectOption"
                              value={state.grade}
                              onChange={(ev) => {
                                setState({
                                  ...state,
                                  grade: ev.target.value,
                                });
                              }}
                              disabled={!state.board} // Disable dropdown if no board is selected
                            >
                              <option>Select Grade * </option>
                              {/* <option value="9">9th</option>
                                                            <option value="10">10th</option>
                                                            <option value="11">11th</option>
                                                            <option value="12">12th</option> */}
                              {subcategories &&
                                subcategories.map((subcategory) => (
                                  <option
                                    key={subcategory.id}
                                    value={subcategory.name}
                                  >
                                    {subcategory.name}
                                  </option>
                                ))}
                            </Form.Select>
                            {errors.grade && (
                              <div className="text-danger">{errors.grade}</div>
                            )}
                          </div>
                        </div>

                        {/* <div className="col-md-6">
                          <div className="mb-3   position-relative">
                            <div className="d-flex align-items-center">
                              <Form.Select
                                className="form-control"
                                aria-label="Default select example"
                                name="selectOption"
                                value={state.language}
                                onChange={(ev) => {
                                  setState({
                                    ...state,
                                    language: ev.target.value,
                                  });
                                }}
                              >
                                <option>Preferred Language * </option>
                                {languages &&
                                  languages.map((language) => (
                                    <option
                                      key={language.id}
                                      value={language.id}
                                    >
                                      {language.name}
                                    </option>
                                  ))}
                              </Form.Select>
                              <OverlayTrigger
                                placement="right"
                                overlay={
                                  <Tooltip id="language-tooltip">
                                    You can watch the videos in English and one
                                    more language. This can be change later
                                    also.
                                  </Tooltip>
                                }
                              >
                                <i className="bi bi-question-circle ms-2" />
                              </OverlayTrigger>
                            </div>
                            {errors.language && (
                              <div className="text-danger">
                                {errors.language}
                              </div>
                            )}
                          </div>
                        </div> */}

                        <div className="col-md-6">
                          <div className="mb-3   position-relative">
                            <Form.Select
                              className="form-control"
                              aria-label="Default select example"
                              name="selectOption"
                              value={state.state}
                              onChange={(ev) => {
                                setState({
                                  ...state,
                                  state: ev.target.value,
                                });
                              }}
                            >
                              <option>Select State * </option>
                              {states &&
                                states.map((state) => (
                                  <option key={state.id} value={state.id}>
                                    {state.name}
                                  </option>
                                ))}
                            </Form.Select>
                            {errors.state && (
                              <div className="text-danger">{errors.state}</div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3   position-relative">
                            <input
                              type="number"
                              defaultValue={state.mobile}
                              className="form-control"
                              placeholder="Mobile No.*"
                              onChange={(ev) => {
                                setState({
                                  ...state,
                                  mobile: ev.target.value,
                                });
                              }}
                            />
                            {errors.phone && (
                              <div className="text-danger">{errors.phone}</div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3   position-relative">
                            <input
                              type="number"
                              defaultValue={state.alternativeNo}
                              className="form-control"
                              placeholder="Alternative Mobile No."
                              onChange={(ev) => {
                                setState({
                                  ...state,
                                  alternativeNo: ev.target.value,
                                });
                              }}
                            />
                            {errors.alternativeNo && (
                              <div className="text-danger">
                                {errors.alternativeNo}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3 position-relative">
                            <div className="d-flex  align-items-center">
                              <input
                                type={showPassword ? "text" : "password"} // Toggle input type
                                className="form-control"
                                defaultValue={state.password}
                                placeholder="Enter your password"
                                onChange={(ev) =>
                                  setState({
                                    ...state,
                                    password: ev.target.value,
                                  })
                                }
                              />
                              <span
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                  cursor: "pointer",
                                  marginLeft: "-30px",
                                }}
                              >
                                {showPassword ?
                                  <FaEyeSlash />
                                : <FaEye />}{" "}
                              </span>
                            </div>
                            {errors.password && (
                              <div className="text-danger">
                                {errors.password}
                              </div>
                            )}
                            {!validatePassword(state.password) &&
                              state.password !== "" &&
                              !errors.password && (
                                <div className="text-primary">
                                  Password must be at least 8 characters, with 1
                                  uppercase letter, 1 number, and 1 special
                                  character.
                                </div>
                              )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3 position-relative">
                            <div className="d-flex  align-items-center">
                              <input
                                defaultValue={state.confirmpassword}
                                className="form-control"
                                placeholder="Confirm Password*"
                                type={`${
                                  showConfirmPassword ? "text" : "password"
                                }`}
                                onChange={(ev) => {
                                  setState({
                                    ...state,
                                    confirmpassword: ev.target.value,
                                  });
                                }}
                              />
                              <span
                                onClick={() =>
                                  setConfirmShowPassword(!showConfirmPassword)
                                }
                                style={{
                                  cursor: "pointer",
                                  marginLeft: "-30px",
                                }}
                              >
                                {showConfirmPassword ?
                                  <FaEyeSlash />
                                : <FaEye />}{" "}
                              </span>
                            </div>
                            {errors.confirmpassword && (
                              <div className="text-danger">
                                {errors.confirmpassword}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="col d-flex justify-content-center align-item-center">
                            <ReCAPTCHA
                              sitekey="6LdOhwQrAAAAAPEnW5DLqd078hsiQGXGy3NC0I6q"
                              onChange={onChange}
                            />
                          </div>
                        </div>
                      </div>

                      <div>
                        {captchaErrorMessage && (
                          <span className="text-danger">
                            {captchaErrorMessage}
                          </span>
                        )}
                      </div>

                      <p className=" mt-2 f13 text-center d-block">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="flexCheckDefault"
                          checked={state.tnc}
                          onChange={(ev) => {
                            setState({
                              ...state,
                              tnc: ev.target.checked,
                            });
                          }}
                        />{" "}
                        By signing up, I accept EFH{" "}
                        <Link
                          to="/terms-and-conditions"
                          className="text-primary"
                        >
                          {" "}
                          Terms & Conditions
                        </Link>
                        {errors.tnc && (
                          <div className="text-danger">{errors.tnc}</div>
                        )}
                      </p>

                      <div className="text-center mt-2 mb-2">
                        <button
                          type="submit"
                          className="btn btn-primary2 btn-block"
                          disabled={loader}
                        >
                          {loader && (
                            <span className="spinner-border spinner-border-sm"></span>
                          )}
                          Sign Up
                        </button>
                      </div>
                    </form>
                    <div className="new-account  mt-3 mb-5 hide">
                      <div className=" mb-3 mt-3 text-center orLoignWith">
                        <span> Or log in with </span>
                      </div>

                      <ul className="social-media-login hide">
                        <li className="facebook">
                          {" "}
                          <FaFacebookF />
                        </li>

                        <li className="google">
                          <BsGoogle />
                        </li>

                        <li className="instagram">
                          <AiFillInstagram />
                        </li>
                      </ul>

                      <p className=" f14 text-center d-block">
                        {" "}
                        <Link to="/login" className="text-primary">
                          {" "}
                          Already have an account? Log In
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisterModal;
